export const classifyLead = (feedback) => {
    if (feedback.purchase_plan.toString() === "0") return "Hot";
    if (feedback.purchase_plan.toString() === "1" || feedback.purchase_plan.toString() === "2") return "Warm";
    if (feedback.purchase_plan.toString() === "3") return "Cold";
    return "Junk";
}

export const STATUS_COLORS = {
  Hot: "#ff4d04",
  Warm: "#fb923c",
  Cold: "#facc15",
  Junk: "#d1d5db",
};

export const HIGHLIGHT = {
  Hot: "bg-[#ff4d04] text-white",
  Warm: "bg-orange-400 text-white",
  Cold: "bg-yellow-400 text-slate-800",
  Junk: "bg-gray-300 text-slate-700",
};